import React from 'react'
import { Tooltip } from '@material-ui/core'
import HelpIcon from '@material-ui/icons/Help'
import { COLORES } from '../../../../config/colores'

function InfoCantidadAdicional (props) {
  const { productos, titulo, cantidad = 0, shortcut = null } = props

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-end',
        margin: '2% auto'
      }}
    >
      {cantidad > 0 &&
      <>
        <Tooltip
          title={<>
            { productos.map((p, i) => {
              return (
                <div key={i}>
                  <b>{p.cereal}</b> : <b>{p.cantidad}</b>
                </div>
              )
            })}
          </>
          }
        >
          <HelpIcon style={{ color: COLORES.grey.dark, margin: '0 8px' }} />
        </Tooltip>

        <h5
          style={{
            fontSize: '1.1rem',
            color: COLORES.grey.dark,
            margin: '0 12px 0 0',
            display: 'flex',
            alignItems: 'baseline'
          }}
        >
          {titulo}: { shortcut ? <span style={{ display: 'inline-block' }}> { shortcut() } </span> : <b>{cantidad}</b> }
        </h5>

      </>
      }
    </div>
  )
}

export default InfoCantidadAdicional
